import { Button } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, ServerSideRowModelModule } from 'ag-grid-enterprise';
import { ServerGridConfig } from '../../../../config/GridConfig';
import Message from '../../../../config/Message';
import {
	faEye,
	faImage,
	faPencil,
	faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { popularityType } from '../../../../config/Global';

const ListComponent = observer((props) => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	const { openEditModal, openDeleteModal, openViewModal, openImageModal } =
		props;
	const { TEMPLE } = useStore();

	const ActionRenderer = (props) => {
		return (
			<div className="action-column">
				<Button
					type="text"
					title={
						props.data.imageApproved
							? 'Approved'
							: 'Pending Approval'
					}
					// disabled={props.data.imageApproved}
					className="imgIcon"
					onClick={() => {
						TEMPLE.ReadTempleImagedetail({
							tableName: 'temple',
							templeID: props.data.id,
						});
						openImageModal(props.data.id);
					}}
				>
					<FontAwesomeIcon
						color={props.data.imageApproved ? '#ff6f00' : '#000'}
						icon={faImage}
					/>
				</Button>
				<Button
					type="text"
					title={'View'}
					className="viewIcon"
					onClick={() => {
						TEMPLE.ReadTempleBasicList(props.data.id);
						openViewModal();
					}}
				>
					<FontAwesomeIcon color="#9dad17" icon={faEye} />
				</Button>
				<Button
					type="text"
					title={'Edit'}
					className="editIcon"
					onClick={() => {
						TEMPLE.ReadTempleBasicList(props.data.id);
						openEditModal();
					}}
				>
					<FontAwesomeIcon color="#1723ad" icon={faPencil} />
				</Button>
				<Button
					type="text"
					title={'Delete'}
					className="deleteIcon"
					onClick={() => {
						openDeleteModal(props.data);
					}}
				>
					<FontAwesomeIcon icon={faTrashAlt} color={'red'} />
				</Button>
			</div>
		);
	};

	const colDefs = [
		// {
		// 	headerName: 'Sr. No',
		// 	valueGetter: 'node.rowIndex + 1',
		// 	headerCheckboxSelection: true,
		// 	checkboxSelection: true,
		// 	minWidth: 80,
		// 	maxWidth: 100,
		// 	sortable: false,
		// },
		{
			headerName: 'Temple Name',
			field: 'templeName',
			sort: 'asc',
			minWidth: 140,
		},
		{
			headerName: 'Popularity',
			field: 'popularity',
			minWidth: 140,
			cellRenderer: (param) =>
				`${param.data.popularity} - ${param.data.popularityKey}`,
		},
		{
			headerName: 'City Name',
			field: 'cityName',
			minWidth: 140,
		},
		{
			headerName: 'State Name',
			field: 'stateName',
			minWidth: 140,
		},
		{
			headerName: 'Image Approved',
			field: 'imageApproved',
			minWidth: 140,
			cellRenderer: (param) =>
				param.data.imageApproved ? 'True' : 'False',
		},
		{
			headerName: 'Actions',
			field: 'actions',
			cellRenderer: 'ActionRenderer',
			pinned: 'right',
			sortable: false,
			filter: false,
			minWidth: 130,
			width: 130,
		},
	];

	return (
		<div
			className="ag-theme-quartz" // applying the grid theme
			style={{ height: 'calc(100vh - 140px)' }} // the grid will fill the size of the parent container>
		>
			<AgGridReact
				onGridReady={TEMPLE.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
				rowSelection={'multiple'}
				components={{
					ActionRenderer,
				}}
			/>
		</div>
	);
});
export default ListComponent;
